import Company from "./Company";
import Model from "./Model";
import ScoutingPlace from "./ScoutingPlace";
import ScoutingArea from "@/models/ScoutingArea";
import { LocationCounter } from "@/models/LocationCounter";
import ScoutingMedium from "@/models/ScoutingMedium";
import MediumCoverage from "@/models/MediumCoverage";
import ScoutingGroup from "@/models/ScoutingGroup";

export enum ScountingStatuses {
  Draft = "draft",
  Analyzed = "analyzed",
}

export class ScoutingFilter {
  companyId?: string;
  page?: number;
  per?: string;

  toParams() {
    const params = [];
    if (this.companyId) {
      params.push(`filter[companyId]=${encodeURIComponent(this.companyId)}`);
    }
    if (this.page && this.page > 0) {
      params.push(`page=${encodeURIComponent(this.page)}`);
    }
    if (this.per && this.per.length > 0) {
      params.push(`per=${encodeURIComponent(this.per)}`);
    }
    const base = "?include=*";
    if (params.length > 0) {
      return `${base}&${params.join("&")}`;
    }
    return base;
  }
}

export interface ScoutingMetadata {
  regions?: number;
  districts?: number;
  towns?: number;
  populations?: number;
  equivalentPopulations?: number;
  families?: number;
  commercialDensity?: number;
  agePopulations?: [{ label: string; value: number }];
  educationPopulations?: [{ label: string; value: number }];
  familyPopulations?: [{ label: string; value: number }];
  jobPopulations?: [{ label: string; value: number }];
  consumptionPopulations?: [{ label: string; value: number }];
  localUnitPopulations?: [{ label: string; value: number }];
  youngAgePopulations?: [{ label: string; value: number }];
}

type ScountingSteps = "poi" | "isocron" | "completed";

export default class Scouting extends Model {
  static type = "scoutings";
  scoutingPlaces!: ScoutingPlace[];
  scoutingAreas!: ScoutingArea[];
  status!: ScountingStatuses;
  isocronType!: string;
  isocronMeansType!: string;
  isocronRange!: number;
  analysisName?: string;
  metadata!: ScoutingMetadata;
  lastUpdatedDate?: string;
  mediumCoverages?: MediumCoverage[];
  scoutingMedia?: ScoutingMedium[];
  scoutingGroups!: ScoutingGroup[];

  get toJson() {
    return { id: this.id };
  }

  get hasIsocron() {
    return this.isocronMeansType && this.isocronRange && this.isocronType;
  }
}

export enum AnalysisState {
  Brief = "brief",
  National = "national",
  POI = "poi",
  Area = "area",
  Group = "group",
}

export class ScoutingAnalysis {
  scouting!: Scouting;
  locationCounter!: LocationCounter;
  status: AnalysisState = AnalysisState.Brief;

  totalRegions!: number;
  totalDistricts!: number;
  totalTowns!: number;
}
